import React from 'react'
import { Box } from '@mui/material'
import theme from '../theme'

interface Props {
  header: React.ReactNode
  content: React.ReactNode
}

const StackedSectionLayout = ({ header, content }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.space['80']
      }}
    >
      <Box
        sx={{
          padding: '20px',
          backgroundColor: theme.palette['base-white']
        }}
      >
        <Box
          sx={{
            width: '100%',
            backgroundColor: theme.palette.background.default,
            borderRadius: theme.borders['rounded-18'],
            padding: theme.space['20']
          }}
        >
          {header}
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'fit-content',
          padding: '0 20px'
        }}
      >
        {content}
      </Box>
    </Box>
  )
}

export default StackedSectionLayout
